// import sriram_rajaram from '../../../assets/img/partnerPortal/welcomeWipro/sriram.png';
// import prakash_murali from '../../../assets/img/partnerPortal/welcomeWipro/prakash.png';
import custom from "../../../assets/img/partnerPortal/welcomePage/innovate.png";
import gartner_banner from "../../../assets/img/partnerPortal/welcomePage/gartner_banner.png";
import perform_banner from "../../../assets/img/partnerPortal/welcomePage/perform_banner.jpg";

import News from "../../../models/common/News";
import Contact from "../../../models/common/Contact";
import Item from "../../../models/common/Item";
import Banner from "../../../models/common/Banner";

// BANNER
export const TITLE = (
  <div>
    Welcome to your<br></br>Partner Portal
  </div>
);
export const SUB_TITLE = (
  <div>
    Can’t find the resources and support you’re looking for? Let’s chat.
  </div>
);
export const ABOVE_TITLE = "ADVANCED PARTNER";
export const BUTTON_NAME = "Register a deal";
export const BUTTON_LINK = "https://partners.dynatrace.com/#/page/sales";
// --

// BANNERS
const banner0: Banner = new Banner(
  "https://www.dynatrace.com/gartner-magic-quadrant-for-observability-platforms/?utm_med[…]race&utm_campaign=partner&utm_content=portal&utm_term=q2fy25",
  "_parent",
  "100%",
  gartner_banner
);
const banner1: Banner = new Banner(
  "https://www.dynatrace.com/perform/partner-summit/?utm_medium=partner&utm_source=dynatrace&utm_campaign=partner&utm_content=portal&utm_term=q4fy25",
  "_parent",
  "100%",
  perform_banner
);
const banner2: Banner = new Banner(
  "https://www.dynatrace.com/innovate/?utm_medium=partner&utm_source=dynatrace&utm_campaign=innovate&utm_content=partner-portal&utm_term=25",
  "_parent",
  "100%",
  custom
);
export const ALL_BANNERS: Array<Banner> = new Array<Banner>(banner0, banner1);

// CONTACTS

const dynaContact1: Contact = new Contact(
  "Sriram Rajaram",
  "Global Relationship Manager",
  "sriram.rajaram@dynatrace.com",
  "Tel. +91 910-844-6447"
);
export const ALL_DYNA_CONTACT_LIST: Array<Contact> = new Array<Contact>(
  dynaContact1
);

const partnerContact1: Contact = new Contact(
  "Prakash Murali",
  "Chief Growth Office",
  "prakash.murali@wipro.com",
  "Tel. +91 951-331-7537"
);
export const ALL_PARTNER_CONTACT_LIST: Array<Contact> = new Array<Contact>(
  partnerContact1
);
// --

// NEWS AND EVENTS
const news33: News = new News(
  "Perform and Innovate Sponsor Prospectus FY26",
  "https://partners.dynatrace.com/content/8a99822b95b0e7e80195b4734ee018f8",
  true,
  true,
  true,
  undefined,
  "Read more"
);
const news32: News = new News(
  "Watch Perform on-demand​",
  "https://www.dynatrace.com/perform/",
  true,
  true,
  true,
  undefined,
  "Watch now"
);
const news31: News = new News(
  "Dynatrace Introduces Observability for Developers​",
  "https://www.dynatrace.com/news/press-release/dynatrace-introduces-observability-for-developers/",
  true,
  true,
  true,
  undefined,
  "Read more"
);
const news30: News = new News(
  "Dynatrace Partners with Visa Cash App Racing Bulls (VCARB) Formula One™ Team​",
  "https://www.dynatrace.com/news/press-release/dynatrace-partners-with-visa-cash-app-racing-bulls-vcarb-formula-one-team-as-official-observability-performance-analytics-technology-partner/",
  true,
  true,
  true,
  undefined,
  "Read more"
);
const news29: News = new News(
  "Streaming event: Dynatrace & the Power of Possible​",
  " https://webinars.techstronglearning.com/dynatrace-and-the-power-of-possible?utm_medium=partner&utm_source=dynatrace&utm_campaign=virtual-event&utm_content=portal&utm_term=q3fy25",
  false,
  true,
  true
);
const news27: News = new News(
  "Partners lead with Dynatrace SaaS​",
  "https://partners.dynatrace.com/#/collateral/8a9983ce90d6f9a50190f221a5f121bd",
  false,
  true,
  true
);
const news26: News = new News(
  "Dynatrace named a Leader in the 2024 Gartner® Magic Quadrant™ for Observability Platforms​",
  "https://www.dynatrace.com/gartner-magic-quadrant-for-observability-platforms/?utm_medium=partner&utm_source=dynatrace&utm_campaign=partner&utm_content=portal&utm_term=q2fy25",
  false,
  false,
  true
);

const event13: News = new News(
  "Learn how to master the Dynatrace Partner Deliver Toolkit",
  "https://info.dynatrace.com/noram-all-wb-partner-delivery-toolkit-26404-od-fulfillment.html?utm_medium=partner&utm_source=dynatrace&utm_campaign=portal&utm_content=all-active-partners&utm_term=none&mkt_tok=MzUyLU5WTy01NjIAAAGY5uZvOiRelPaOTN3vSicEXtUu1G4fcCPHd0QPVHj8YbfjrjGTV3GCMjiUFZaQKdEbZlgiU3boBximTOnaZiQb",
  true,
  true,
  true,
  "On-Demand Webinar",
  "Watch now"
);
const event17: News = new News(
  "Recap the 2025 Partner Keynote",
  "https://partners.dynatrace.com/#/page/perform-2025-on-demand",
  true,
  true,
  true,
  "On-Demand Webinar",
  "Watch now"
);

export const ALL_EVENTS_LIST: Array<News> = new Array<News>(
  news33,
  news32,
  news31,
  news30,
  news29,
  news27,
  news26,
  event13,
  event17
);

// VIDEOS
const video3: News = new News(
  "12 July: What's next for digital transformation? Observability and beyond",
  "https://partners.dynatrace.com/#/page/wp_digital_transformation",
  false,
  true,
  true,
  "",
  "watch the video"
);
const video2: News = new News(
  "21 June: Beyond APM-AI, DevOps, observability & security",
  "https://partners.dynatrace.com/#/page/wp_beyond_apm",
  false,
  true,
  true,
  "",
  "watch the video"
);
const video1: News = new News(
  "9 August: Intelligent observability - Why metrics, logs, and traces aren't enough",
  "https://partners.dynatrace.com/#/page/wp_intelligent_obs",
  false,
  true,
  true,
  "",
  "watch the video"
);
export const WIPRO_VIDEO_PAGES: Array<News> = new Array<News>(
  video3,
  video2,
  video1
);

// ITEMS
const item1: Item = new Item(
  "XL Axiata, APAC",
  "View PPT",
  "https://partners.dynatrace.com/#/collateral/8a998a608e12e37a018e1965a46a2895"
);
const item2: Item = new Item(
  "Xerox Corporation, NORAM",
  "View PPT",
  "https://partners.dynatrace.com/#/collateral/8a9993aa8e12e37b018e1966fd610f51"
);
const item3: Item = new Item(
  "Roads & Maritime, APAC",
  "View PPT",
  "https://partners.dynatrace.com/#/collateral/8a998a608e12e37a018e1967f7a5299e"
);
export const ALL_ITEMS_LIST: Array<Item> = new Array<Item>(item1, item2, item3);

// TOOLS
const tool1: Item = new Item(
  "Quick Reference Guide - CloudOps Automation",
  "View PDF",
  "https://partners.dynatrace.com/#/collateral/8a998a608e12e37a018e1dd0280e31ee"
);
const tool2: Item = new Item(
  "Quick Reference Guide - Intelligent Observability",
  "View PDF",
  "https://partners.dynatrace.com/#/collateral/8a9983cf8e1b6d3a018e1dd0089a2480"
);
const tool3: Item = new Item(
  "Quick Reference Guide - Wipro and Dynatrace joint elevator pitch",
  "View PDF",
  "https://partners.dynatrace.com/#/collateral/8a998a0587f7df4c01881101a7577c2c"
);
const tool4: Item = new Item(
  "Wipro Cloud Studio - Wipro’s differentiated cloudification starts from Cloud assessment leveraging Dynatrace, Cloud migration through pre-built Cloud native application blueprints for development, integration and insights and ongoing operations supported to accelerates time to market through Wipro ACS™ - Autonomous Cloud offering.",
  "View PPT",
  "https://partners.dynatrace.com/#/collateral/8a9993aa8e12e37b018e1969b35110e0"
);
const tool5: Item = new Item(
  "Automation of processes provides more time to the data scientists for application of their thought to reach actionable insights. The BEE Model created is stored and reused as and when the need arises. Combined with the power of the Cloud to easily scale based on the amount of data, models can be trained effortlessly, and deployment is automated. This will dramatically accelerate the time needed to build, scale, and deploy project.",
  "View PPT",
  "https://partners.dynatrace.com/#/collateral/8a998a608e12e37a018e196c1af32bb5"
);
const tool6: Item = new Item(
  "End to end Infrastructure and Application Performance Management and Minimize IT complexity by bring down number of Tools and touchpoints for faster resolution and save cost.",
  "View PPT",
  "https://partners.dynatrace.com/#/collateral/8a9993aa8e12e37b018e196f52c512c3"
);
export const ALL_TOOLS_LIST: Array<Item> = new Array<Item>(
  tool1,
  tool2,
  tool3,
  tool4,
  tool5,
  tool6
);
